function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("rect", {
  width: 18,
  height: 4,
  rx: 2,
  transform: "translate(7 7)",
  fill: "#2F80ED"
});

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 18,
  height: 4,
  rx: 2,
  transform: "translate(7 14)",
  fill: "#2F80ED"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  width: 18,
  height: 4,
  rx: 2,
  transform: "translate(7 21)",
  fill: "#2F80ED"
});

var SvgIconCoursesActive = function SvgIconCoursesActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none"
  }, props), _ref, _ref2, _ref3);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjE4IiBoZWlnaHQ9IjQiIHJ4PSIyIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg3IDcpIiBmaWxsPSIjMkY4MEVEIi8+CjxyZWN0IHdpZHRoPSIxOCIgaGVpZ2h0PSI0IiByeD0iMiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNyAxNCkiIGZpbGw9IiMyRjgwRUQiLz4KPHJlY3Qgd2lkdGg9IjE4IiBoZWlnaHQ9IjQiIHJ4PSIyIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg3IDIxKSIgZmlsbD0iIzJGODBFRCIvPgo8L3N2Zz4K";
export { SvgIconCoursesActive as ReactComponent };